export class PingBodyOverflowError extends Error {
    constructor(message) {
        super(message);
        this.name = "PingBodyOverflow";
    }
}
